import { render, staticRenderFns } from "./OldMag2Year.vue?vue&type=template&id=a8e8b462&scoped=true&"
import script from "./OldMag2Year.vue?vue&type=script&lang=js&"
export * from "./OldMag2Year.vue?vue&type=script&lang=js&"
import style0 from "./OldMag2Year.vue?vue&type=style&index=0&id=a8e8b462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e8b462",
  null
  
)

export default component.exports